export const headerBaseCssClassNames = {
    root: 'Header-root',
    bar: 'Header-bar',
    barContainer: 'Header-barContainer',
    link: 'Header-link',
    searchInput: 'Header-searchInput'
};
export const headerMobileCssClassNames = {
    append: 'Header-append',
    appendLink: 'Header-appendLink',
    mobileMenuButton: 'Header-mobileMenuButton',
    searchMobileButton: 'Header-searchMobileButton',
    searchPopover: 'Header-searchPopover',
    mobileNavigation: 'Header-mobileNavigation'
};
export const headerDesktopCssClassNames = {
    actionArea: 'Header-actionArea',
    divider: 'Header-divider',
    logo: 'Header-logo',
    navigation: 'Header-navigation',
    title: 'Header-title'
};
export const headerCssClassNames = {
    ...headerBaseCssClassNames,
    ...headerMobileCssClassNames,
    ...headerDesktopCssClassNames
};
